import { FC, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Backdrop, Button, Modal } from '@mui/material';
import SecondTypeButton from 'src/components/Items/button/SecondTypeButton';
import CustomCheckbox from 'src/components/Items/button/CustomCheckbox';
import PickupDetailsFormModal from './PickupDetailsForm';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { validateField } from 'src/common/utils/validation';
import { PickupDetails } from 'src/entity/PickupDetails';
import { IPickupDetails } from 'src/models/IPickupDetails';
import './styles.scss';

interface IProps {
  open: boolean;
  handleClose: () => void;
}

export type IErrorsPdData = {
  location?: string | undefined;
  return_at?: string | undefined;
  description?: string | undefined;
  host_id?: string | undefined;
  for_all?: boolean | undefined;
  address_take?: string | undefined;
  address_drop?: string | undefined;
};

const PickupDetailsModal: FC<IProps> = ({ open, handleClose }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { addPickupDetails } = useActions();
  const {
    auth: { id, role },
    pickupDetails: { pickupDetailsList }
  } = useTypedSelector(state => state);
  const [pd, setPd] = useState<IPickupDetails>(new PickupDetails());
  const [mainLocation, setMainLocation] = useState('');
  const [check, setCheck] = useState(false);
  const [errors, setErrors] = useState<IErrorsPdData>({});
  const [disable, setDisable] = useState(false);

  const handleInput = (name: string) => (value: any) => {
    if (name === 'location') {
      if (value.location) {
        setPd({ ...pd, location: value.name });
        setMainLocation(value.location);
      } else {
        setPd({ ...pd, [name]: value });
        setMainLocation('');
      }
    } else if (name === 'host_id') {
      setPd({ ...pd, [name]: value.target.value });
    } else setPd({ ...pd, [name]: value });
  };

  function chengeCheckbox() {
    setPd({ ...pd, for_all: !pd.for_all });
  }

  useEffect(() => {
    if (role !== 'host') {
      pd.for_all ? (setDisable(true), setPd({ ...pd, host_id: null })) : setDisable(false);
    } else {
      setDisable(true);
      setPd({ ...pd, host_id: [id!] });
    }
  }, [open, id, role, pd.for_all]);

  const validateInputs = (): boolean => {
    let location = validateField(pd.location);
    const return_at = validateField(pd.return_at);
    const description = validateField(pd.description);
    const address_take = validateField(pd.address_take);
    const address_drop = validateField(pd.address_drop);
    let host_id = pd.for_all ? '' : pd.host_id === null ? 'Field can not be empty' : '';

    const isExist = pickupDetailsList.find(
      el =>
        el.location === pd.location &&
        ((pd.for_all && el.for_all) ||
          (Array.isArray(pd.host_id) && pd.host_id.find(h => h === el.host_id)))
    );

    if (isExist) {
      location = 'Pickup Details already exist';
      host_id = 'Pickup Details already exist';
      enqueueSnackbar('Pickup Details already exist', {
        variant: 'error'
      });
    }

    setErrors({
      location,
      return_at,
      host_id,
      description,
      address_take,
      address_drop
    });
    return [location, return_at, host_id, description, address_take, address_drop].every(el => !el);
  };

  const handleCloseModal = () => {
    setPd(new PickupDetails());
    setCheck(false);
    setErrors({});
    handleClose();
  };

  const handleSubmit = () => {
    setCheck(true);
    if (validateInputs()) {
      setPd(new PickupDetails());
      setCheck(false);
      setErrors({});
      handleCloseModal();
      let newArray;
      if (pd.host_id) {
        newArray = (pd.host_id! as number[]).map(id => ({
          ...pd,
          location: mainLocation ? `${mainLocation}__${pd.location}` : pd.location,
          host_id: id
        }));
      } else {
        newArray = [
          {
            ...pd,
            location: mainLocation ? `${mainLocation}__${pd.location}` : pd.location
          }
        ];
      }
      addPickupDetails(newArray);
    }
  };

  return (
    <Modal open={open} onClose={handleCloseModal} BackdropComponent={Backdrop} closeAfterTransition>
      <div className='modal modal-850'>
        <div className='modal__title'>Add Pickup Details</div>
        <PickupDetailsFormModal
          pd={pd}
          setPd={handleInput}
          check={check}
          errors={errors}
          disable={disable}
          isCreate
        />
        {role !== 'host' ? (
          <div className='pd-modal__checkbox-container'>
            <CustomCheckbox onChange={chengeCheckbox} checked={pd.for_all} name='for all' />
            <p className='filter__title'>Default</p>
          </div>
        ) : (
          <></>
        )}
        <div className='col-2 modal__buttons'>
          <SecondTypeButton children='Cancel' onClick={handleCloseModal} />
          <Button variant='contained' onClick={handleSubmit} children='Add Pickup Details' />
        </div>
      </div>
    </Modal>
  );
};
export default PickupDetailsModal;
